<template>
  <div class="flex flex-wrap mt-4 min-height-view">
    <div class="w-full mb-12 px-4">
      <card-history/>
    </div>
  </div>
</template>
<script>
import CardHistory from "@/components/Cards/User/CardHistory.vue";

export default {
  components: {
    CardHistory,
  },
};
</script>
